import ko from './ko.json';
import en from './en.json';
import zh from './zh.json';
import tr from './tr.json';
import pt from './pt.json';
import hi from './hi.json';
import es from './es.json';
import de from './de.json';
import it from './it.json';
import pl from './pl.json';
import cs from './cs.json';
import uk from './uk.json';
import uz from './uz.json';

const translations = { ko, en, zh, tr, pt, hi, es, de, it, pl, cs, uk, uz };
export default translations;
